import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { useFeatureFlagContext } from 'restaurantAdmin/featureFlags';

export const useIsLightspeedEnabled = (): boolean => {
  const { isEnabled } = useFeatureFlagContext();
  const { lightspeedBusinessLocationId } = useRestaurant();

  return isEnabled('lightspeedIntegration') && !!lightspeedBusinessLocationId;
};
